export const fileToBase64DataUrl = (file: File): Promise<string> =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (): void => resolve(reader.result?.toString() ?? '');
    reader.onerror = (error): void => reject(error);
    reader.readAsDataURL(file);
  });
